import { NativeBridge } from "@swiggy-private/native-bridge";

let bridgeSdk: NativeBridge | null = null;

export const initBridgeSdk = (sdk?: NativeBridge): NativeBridge => {
    if (bridgeSdk && !sdk) {
        return bridgeSdk;
    }

    bridgeSdk = sdk || new NativeBridge(null);
    return bridgeSdk;
};

/**
 * get instance for bridge sdk via getBridgeSdk
 * @returns instance for bridge SDK
 */
export const getBridgeSdk = (): NativeBridge => bridgeSdk || initBridgeSdk();

export const getSwiggyHeadersFromNB = (sdk: NativeBridge) => {
    return sdk.getSwiggyHeadersDataFromClient();
};

export const closeWebView = (sdk: NativeBridge) => {
    return sdk.close();
};

export const normalCloseWebView = () => {
    return getBridgeSdk()
        .close()
        .catch(() => void 0);
};

export const isBrowserEnv = () => {
    return typeof window !== "undefined";
};

export const hideNativeHeader = (sdk: NativeBridge): void => {
    sdk?.showHeader({ show: false, title: "" }).catch(() => void 0);
};
